
  <!-- start template-->
  <div
    class="flex flex-col justify-center"
    *ngIf="!startTemplate && icon">
    <i class="flex text-[2rem] pr-2" 
      [ngClass]=icon></i>
  </div>
  <ng-template *ngTemplateOutlet="startTemplate"></ng-template>

  <!-- main content -->
  <div class="grow flex flex-row"> 

      <!-- label -->
      <div
        *ngIf="!labelTemplate"
        [ngClass]="getLabelClass()">
        {{label | translate}}
      </div>
      <ng-template *ngTemplateOutlet="labelTemplate"></ng-template>

      <!-- tag -->
      <!-- for the tag we keep a containg div here, to make it easier to use
        I dont expect such varying content here. The margin is set for displaying
        tag(s) (p-tag) exactly on the same height as the label -->
      <div
        *ngIf="tagTemplate"
        class="mt-[0.75rem] ml-2">
        <ng-template *ngTemplateOutlet="tagTemplate"></ng-template>
      </div>
  </div>

  <!-- end -->
  <div
    *ngIf="shouldShowButton()"
    class="flex flex-col justify-center ml-2">
    <p-menu
      #menu 
      (onShow)="onMenuShow()"
      (onHide)="onMenuHide()"
      [model]="menuItems" 
      [popup]="true"
      [appendTo]="'body'"></p-menu>
    <nx-default-button
      [ngClass]="{
        'nx-focus': menuVisible
      }"
      (click)="menu.toggle($event)" 
      [icon]="'icon-options'">
    </nx-default-button>
  </div>
  <div class="pt-[0.625rem]">
    <ng-template *ngTemplateOutlet="endTemplate"></ng-template>
  </div>
